import React from 'react'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import styled from 'styled-components'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Image from 'components/Common/Image/Image'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { SolidHalfStar } from 'components/Common/TrustIndicators/SolidHalfStar'
import Clickable from 'components/Common/Clickable'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { SolidFourStars } from './SolidFourStars'

const ImageWrapper = styled.div`
  &.variantA {
    height: ${rem(34)};
    width: ${rem(148)};
  }

  &.variantB {
    width: ${rem(204)};

    ${mediaQueryUp.sm} {
      width: ${rem(240)};
    }
  }
`

const StyledClickable = styled(Clickable)`
  min-width: 50%;

  ${mediaQueryUp.md} {
    min-width: unset;
  }
`

const PRODUCT_REVIEW_LINK = 'https://www.productreview.com.au/listings/luxury-escapes'

interface Props {
  variant: 'variantA' | 'variantB';
}

function ProductReviewTrustIndicator({ variant }: Props) {
  const isVariantA = variant === 'variantA'
  const isVariantB = variant === 'variantB'

  return (
    <StyledClickable href={PRODUCT_REVIEW_LINK} target="_blank">
      {isVariantA && (
        <Group direction="vertical" horizontalAlign="center" verticalAlign="space-between">
          <ImageWrapper className="variantA">
            <Image id="vhgdupabimlzccz1cnsj" fit="center" dpr={3}/>
          </ImageWrapper>
          <Group direction="horizontal" gap={8}>
            <CSSBreakpoint min="sm">
              <Group direction="horizontal" gap={4}>
                <SolidFourStars />
                <SolidHalfStar size="20"/>
              </Group>
            </CSSBreakpoint>
            <BodyText variant="medium" weight="bold">4.4</BodyText>
            <BodyText colour="neutral-three" variant="medium">(5.4k reviews)</BodyText>
          </Group>
        </Group>
      )}
      {isVariantB && (
        <Group direction="vertical" horizontalAlign="center" verticalAlign="center">
          <ImageWrapper className="variantB">
            <Image id="h92bymjd3g77vgyiptla" fit="center" dpr={3} width="240"/>
          </ImageWrapper>
        </Group>
      )}
    </StyledClickable>
  )
}

export default ProductReviewTrustIndicator
